import { cloneDeep } from 'lodash';
import { AfterViewInit, Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';

import { BaseUI } from '../../base.ui';
import { FullClient, ShareHolder } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';
import { ParentFormDirective } from '../../../directives/parent-form.directive';
import { ShareHolderType } from '../../../../core';

@Component({
    selector: 'thr-full-data-two-legal-person',
    templateUrl: './full-data-two-legal-person.component.html',
    styleUrls: ['./full-data-two-legal-person.component.scss'],
})
export class FullDataTwoLegalPersonComponent extends BaseUI implements AfterViewInit, OnDestroy {
    public ShareHolderType: typeof ShareHolderType = ShareHolderType;

    public adding = false;
    public editing = false;
    public currentShareHolder: ShareHolder;

    public form: NgForm;
    public isFormValid = false;

    @Input()
    client: FullClient;

    @Input()
    isDisabled = false;

    @ViewChild('formDirective')
    formDirective: ParentFormDirective;

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.form = this.formDirective.controlContainer as NgForm;

        if (this.form) {
            this.form.statusChanges.subscribe(() => {
                setTimeout(() => {
                    this.isFormValid = this.form.valid;
                });
            });
        }
    }

    onHasMainShareHoldersChange() {
        this.onCancel();

        if (this.client.hasMainShareHolders && this.client.shareHolders.length === 0) {
            this.onAdd(ShareHolderType.SHAREHOLDER);
        }

        this.parentEvents.resize();
    }

    onHasSecondaryShareHoldersChange() {
        this.onCancel();

        if (this.client.hasSecondaryShareHolders && this.client.shareHolders.length === 0) {
            this.onAdd(ShareHolderType.CONTROLLER);
        }

        this.parentEvents.resize();
    }

    onAdd(type: ShareHolderType) {
        this.currentShareHolder = new ShareHolder(type);
        this.adding = true;
        this.editing = false;
    }

    onSave() {
        if (this.adding) {
            this.client.addShareHolder(this.currentShareHolder);
        } else if (this.editing) {
            this.client.updateShareHolder(this.currentShareHolder);
        }

        this.onCancel();
    }

    onCancel() {
        this.adding = false;
        this.editing = false;
        this.currentShareHolder = undefined;

        this.parentEvents.resize();
    }

    onEdit(shareHolder: ShareHolder) {
        this.currentShareHolder = cloneDeep(shareHolder);
        this.editing = true;
        this.adding = false;
    }

    onRemove(shareHolder: ShareHolder) {
        this.client.removeShareHolder(shareHolder);

        if (this.currentShareHolder && String(this.currentShareHolder.id) === String(shareHolder.id)) {
            this.onCancel();
        }

        if (!this.adding && this.client.shareHolders.length === 0) {
            this.onAdd(this.client.hasMainShareHolders ? ShareHolderType.SHAREHOLDER : ShareHolderType.CONTROLLER);
        }

        this.parentEvents.resize();
    }
}
